import D1 from '../maps/D1.json';
import D2 from '../maps/D2.json';
import D3 from '../maps/D3.json';
import D4 from '../maps/D4.json';
import D5 from '../maps/D5.json';
import D6 from '../maps/D6.json';
import D7 from '../maps/D7.json';
import type { DailyMap, DateKey, Mineral } from './types.js';
import { LAYOUTS_V2 } from './layouts-v2.js';
function freezeDeep<T>(value: T): T {
  if (value && typeof value === 'object') { Object.freeze(value); Object.values(value).forEach(freezeDeep); }
  return value;
}
export const LEGACY_MAP_VERSION = 'maps.v1';
export const MAP_VERSION = 'maps.v2';
const LEGACY_MAPS = freezeDeep({ D1, D2, D3, D4, D5, D6, D7 } as Record<DateKey, DailyMap>);
function publishMap(source: DailyMap): DailyMap {
  const layout = LAYOUTS_V2[source.dateKey];
  const move = (objects: readonly Mineral[], positions: [number, number][]) => objects.map((object, index) => ({ ...object, x: positions[index]![0] * 1000, y: positions[index]![1] * 1000 }));
  return { ...source, mapVersion: MAP_VERSION, A: move(source.A, layout.A), B: move(source.B, layout.B) };
}
export const MAPS = freezeDeep(Object.fromEntries(Object.entries(LEGACY_MAPS).map(([key, map]) => [key, publishMap(map)])) as Record<DateKey, DailyMap>);
export const maps = MAPS;
export function getMap(dateKey: DateKey, version = MAP_VERSION): DailyMap {
  if (![MAP_VERSION, LEGACY_MAP_VERSION].includes(version)) throw new Error('Unknown map version');
  const map = (version === LEGACY_MAP_VERSION ? LEGACY_MAPS : MAPS)[dateKey];
  if (!map) throw new Error('Unknown activity date');
  return map;
}
export const DAILY_LESSONS = Object.freeze({
  D1: { focus: '认识出钩、自动回收和100%目标', route: '先走直线路径，观察第一钩的反馈', tool: '任意工具都可完成', mistake: '空钩会自动回收，重新瞄准即可' },
  D2: { focus: '比较近处小矿与远处大矿', route: '近处稳收或远处高价值，按时间取舍', tool: '慢摇帮助控制路线', mistake: '不要为大矿连续等待过久' },
  D3: { focus: '练习角度控制', route: '利用慢摇覆盖三次瞄准', tool: '慢摇降低摆动速度', mistake: '工具不是强制通关条件' },
  D4: { focus: '看懂盲盒的进度作用', route: '盲盒增加进度，但不提供工具', tool: '准钩辅助下一钩', mistake: '盲盒会中断金矿连中' },
  D5: { focus: '判断石头阻挡和绕开路线', route: '可用炸弹，也可绕开石头', tool: '炸弹只在拖回石头时可用', mistake: '炸弹不可提前使用' },
  D6: { focus: '规划连续金矿路线', route: '连续收回金矿可保留连中', tool: '慢摇帮助连续瞄准', mistake: '石头、盲盒和品牌矿会中断连中' },
  D7: { focus: '综合路线与主题宝藏', route: '黄金龙提供清晰反馈，未抓到也可完成目标', tool: '按路线选择工具', mistake: '不要为了宝藏放弃100%进度' },
} as const);
